/**************************************************
 * Nombre:       Formulario_Suscripcion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {AccountCircleOutlined, CakeOutlined, Mail, PhoneAndroid, WhatsApp} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";


const Formulario_Suscripcion = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={12}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'}
                                  dato={'nombre'} {...props} requerido={'Campo requerido'}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Mail} nombre={'Correo Electrónico'}
                                  dato={'correo'} {...props} requerido={'Campo requerido'}

                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={WhatsApp} nombre={'WhatsApp (Sin +57)'} ejemplo={'3001122333'}
                                  dato={'celular'} {...props} requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoFecha Icono={CakeOutlined} nombre={'Fecha de cumpleaños'}
                                  dato={'fechaCumple'} {...props} requerido={'La fecha de cumpleaños es requerida'}
                    />
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Suscripcion